module.exports = __webpack_public_path__ + "img/icon_tag_meals.68f32876.svg";